import axios from "axios";
import moment from "moment";
import { useState } from "react";
import Swal from "sweetalert2";

// Wires Smart Calendar as the trigger point for Channel Manager: pushes the
// currently visible month's availability/rates/restrictions for one room
// out to every OTA channel it's mapped to (see /admin/channelmanager).
export const useSyncToChannels = ({ currentMonth, selectedYear }) => {
  const [syncingRoomId, setSyncingRoomId] = useState(null);

  const handleSyncToChannels = async (roomId) => {
    const monthStart = moment(
      `1-${currentMonth.month() + 1}-${selectedYear}`,
      "D-M-YYYY"
    );
    const today = moment();
    const fromDate = (monthStart.isAfter(today, "day") ? monthStart : today).format(
      "DD-MM-YYYY"
    );
    const toDate = moment(monthStart).endOf("month").format("DD-MM-YYYY");

    setSyncingRoomId(roomId);
    try {
      const res = await axios.post("/api/channelmanager/sync", {
        roomId,
        fromDate,
        toDate,
      });

      const { availability = [], rates = [], restrictions = [] } = res.data.results || {};
      const allPushes = [...availability, ...rates, ...restrictions];
      const failed = allPushes.filter((p) => !p.success);

      if (allPushes.length === 0) {
        Swal.fire(
          "Nothing to sync",
          "No channel is configured (propertyCode) for this room yet — check Channel Manager settings.",
          "info"
        );
      } else if (failed.length === 0) {
        Swal.fire(
          "Synced",
          `Pushed to ${allPushes.length} channel update(s) successfully.`,
          "success"
        );
      } else {
        Swal.fire(
          "Synced with errors",
          `${failed.length}/${allPushes.length} pushes failed. Check the Sync Log tab in Channel Manager for details.`,
          "warning"
        );
      }
    } catch (error) {
      Swal.fire(
        "Sync failed",
        error.response?.data?.message || "Failed to sync to channels",
        "error"
      );
    } finally {
      setSyncingRoomId(null);
    }
  };

  return { syncingRoomId, handleSyncToChannels };
};
